// extracted by mini-css-extract-plugin
export default {"card":"ParagraphGeneratorForm_card__sCaUL","input":"ParagraphGeneratorForm_input__1hS8r"};